// ...existing code...
import { Component, OnDestroy } from '@angular/core';
import { AppointmentAvailability, AppointmentService, ModalService, SwalService } from '../../../../core/services';
import { environment } from '../../../../../environments';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { finalize } from 'rxjs';
import Swal from 'sweetalert2';
interface PaymentType {
  id: string;
  label: string;
  description?: string;
  icon?: string | null;
}

@Component({
  selector: 'app-make-payment',
  imports: [
    CommonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './make-payment.component.html',
  styleUrl: './make-payment.component.scss'
})
export class MakePaymentComponent implements OnDestroy {
 isDppTheme = environment.theme.default === 'dpp';
  links = [{ label: 'Rendez-vous', href: undefined }];

  // Pagination
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;
  Math = Math; // Make Math available in template
  paymentForm: FormGroup;
  isProcessing = false;
  selectedPaymentType: string | null = null;
  qrImageUrl: string | null = null;
  polling = false;
   pollIntervalRef: any = null;
   pollAttempts = 0;
   maxPollAttempts = 40; // ~40 * 3s = 120s
   pollDelay = 3000;

  // add current payment reference for polling / template if needed
  currentPaymentRef: string | null = null;

  // QR + polling

  paymentTypes: PaymentType[] = [
    { id: 'mastercard_card', label: 'Mastercard', icon: 'assets/images/master.png' },
    { id: 'orange_money', label: 'Orange Money', icon: 'assets/images/om.png' },
    { id: 'maxit', label: 'Maxit', icon: 'assets/images/maxit.png' },
    { id: 'free_money', label: 'Free Money', icon: 'assets/images/free.webp' },
    { id: 'wave_money', label: 'Wave Money', icon: 'assets/images/wave.png' },
  ];
  // Données des rendez-vous
  appointments: AppointmentAvailability[] = [];
  loading = false;

  constructor(
    private appointmentService: AppointmentService,
    private swalService: SwalService,
    private modalService: ModalService,
    private fb: FormBuilder
  ) {
    this.paymentForm = this.fb.group({
      // card fields
      cardNumber: [''],
      expiry: [''],
      cvv: [''],
      cardHolder: [''],

      // tokenized card
      token: [''],

      // mobile money / phone-based
      phone: [''],
      holderName: [''],
      pin: [''],

      // optional amount
      amount: [10, [Validators.required, Validators.min(1)]],
    });
    }

  ngOnDestroy(): void {
    this.stopPolling();
  }

// ...existing methods (selectPayment, cancelPayment, resetFormControls, applyValidatorsFor, markAllAsTouched, getControl) ...

submitPayment() {
    if (!this.selectedPaymentType) return;

    if (this.paymentForm.invalid) {
      this.markAllAsTouched();
      return;
    }

    this.isProcessing = true;
    this.qrImageUrl = null; // reset previous QR
    const amount = Number(this.paymentForm.get('amount')?.value) || 10;
    const phone = this.paymentForm.get('phone')?.value || '';
    const holderName = this.paymentForm.get('holderName')?.value || this.paymentForm.get('cardHolder')?.value || 'Client';
    const email = ''; // populate if available in your app
    const city = 'Dakar';
    const country = 'SN';

    const paymentTypeParam = this.selectedPaymentType;
    const url = `https://api.test.bictorys.com/pay/v1/charges?payment_type=${paymentTypeParam}`;

    const body: any = {
      customerObject: {
        name: holderName,
        phone: phone.replace(/^\+/, ''), // remove leading + if present
        email,
        address: '',
        city,
        postalCode: 10000,
        country,
        locale: 'fr-FR'
      },
      currency: 'XOF',
      amount,
      paymentReference: `APPOINT_${Date.now()}`,
      deviceId: `WEB-${Math.random().toString(36).slice(2, 9)}`,
      country,
      merchantReference: `SN-${(environment.paymentToken || '').slice(0, 8)}`,
      // successRedirectUrl: window.location.href + '?status=success',
      // errorRedirectUrl: window.location.href + '?status=fails',
      allowUpdateCustomer: true,
      authorization: true
    };

    if (paymentTypeParam === 'mastercard_card') {
      body.card = {
        number: (this.paymentForm.get('cardNumber')?.value || '').toString().replace(/\s+/g, ''),
        expiry: this.paymentForm.get('expiry')?.value,
        cvv: this.paymentForm.get('cvv')?.value,
        holderName: this.paymentForm.get('cardHolder')?.value
      };
    } else if (paymentTypeParam === 'tokenized_card') {
      body.token = this.paymentForm.get('token')?.value;
    }

    // call service - the service should forward the request to the payment provider
    this.appointmentService.payReservation(body, paymentTypeParam)
      .pipe(finalize(() => (this.isProcessing = false)))
      .subscribe({
        next: (res: any) => {
          console.log('Payment response', res);

          // try to extract QR from response
          const qrCandidate = res?.qrCode;
          const paymentRef = res?.transactionId 

          if (qrCandidate) {
            // normalize QR: could be url, base64 w/o prefix, or data URI
            if (typeof qrCandidate === 'string') {
              if (qrCandidate.startsWith('data:image')) {
                this.qrImageUrl = qrCandidate;
              } else if (/^https?:\/\//.test(qrCandidate)) {
                this.qrImageUrl = qrCandidate;
              } else {
                // assume base64 png without prefix
                this.qrImageUrl = `data:image/png;base64,${qrCandidate}`;
              }
            }
            // show user the QR and start polling if we have a reference
            if (this.qrImageUrl) {
              this.swalService.info('Scannez le QR', 'Un QR a été généré. Scannez-le avec votre application de paiement pour confirmer.');
              if (paymentRef) {
                this.startPollingPaymentStatus(paymentRef);
              }
              // keep modal open so user can scan
              return;
            }
          }

          // fallback: if response contains redirectUrl open it
          if (res?.redirectUrl) {
            window.location.href = res.redirectUrl;
            return;
          }

          // otherwise assume immediate success
          this.paymentForm.reset({ amount: 10 });
          this.selectedPaymentType = null;
          this.swalService.success('Paiement', 'Requête de paiement envoyée.');
        },
        error: (err) => {
          console.error('Payment error', err);
          this.swalService.error('Erreur de paiement', err?.error?.message || 'Impossible de lancer le paiement');
        }
      });
  }

  private startPollingPaymentStatus(paymentReference: string) {
    // avoid multiple pollers
    this.stopPolling();
    this.pollAttempts = 0;
    this.polling = true;

    // prefer a service method if available: appointmentService.checkPaymentStatus(paymentReference)
    const checker = (this.appointmentService as any)?.checkPaymentStatus;
    if (typeof checker === 'function') {
      this.pollIntervalRef = setInterval(() => {
        this.pollAttempts++;
        (this.appointmentService as any).checkPaymentStatus(paymentReference).subscribe({
          next: (r: any) => {
            const status = r?.status || r?.paymentStatus || r?.data?.status;
            if (status && /paid|success|completed|succeeded/i.test(status)) {
              this.stopPolling();
              this.swalService.success('Paiement confirmé', 'Le paiement a été confirmé avec succès.');
              this.qrImageUrl = null;
              this.paymentForm.reset({ amount: 10 });
              this.selectedPaymentType = null;
            } else if (this.pollAttempts >= this.maxPollAttempts) {
              this.stopPolling();
              this.swalService.error('Délai dépassé', 'Le paiement n\'a pas été confirmé. Réessayez ou contactez le support.');
            }
          },
          error: (e: any) => {
            console.error('poll error', e);
            if (this.pollAttempts >= this.maxPollAttempts) {
              this.stopPolling();
              this.swalService.error('Erreur', 'Impossible de vérifier le statut du paiement.');
            }
          }
        });
      }, this.pollDelay);
      return;
    }

    // fallback: if appointmentService has no checkPaymentStatus, try generic endpoint via appointmentService.getPaymentStatus (best-effort)
    const checker2 = (this.appointmentService as any)?.getPaymentStatus;
    if (typeof checker2 === 'function') {
      this.pollIntervalRef = setInterval(() => {
        this.pollAttempts++;
        (this.appointmentService as any).getPaymentStatus(paymentReference).subscribe({
          next: (r: any) => {
            const status = r?.status || r?.paymentStatus || r?.data?.status;
            if (status && /paid|success|completed|succeeded/i.test(status)) {
              this.stopPolling();
              this.swalService.success('Paiement confirmé', 'Le paiement a été confirmé avec succès.');
              this.qrImageUrl = null;
              this.paymentForm.reset({ amount: 10 });
              this.selectedPaymentType = null;
            } else if (this.pollAttempts >= this.maxPollAttempts) {
              this.stopPolling();
              this.swalService.error('Délai dépassé', 'Le paiement n\'a pas été confirmé. Réessayez ou contactez le support.');
            }
          },
          error: (e: any) => {
            console.error('poll error', e);
            if (this.pollAttempts >= this.maxPollAttempts) {
              this.stopPolling();
              this.swalService.error('Erreur', 'Impossible de vérifier le statut du paiement.');
            }
          }
        });
      }, this.pollDelay);
      return;
    }

    // no poller available in service — notify user and stop
    this.polling = false;
    this.swalService.info('QR généré', 'Scannez le QR et vérifiez manuellement le paiement. Le statut ne peut pas être vérifié automatiquement.');
  }


  // existing helpers...
  private resetFormControls() {
    // clear values and validators
    Object.keys(this.paymentForm.controls).forEach(k => {
      if (k === 'amount') {
        this.paymentForm.get(k)?.setValue(10);
      } else {
        this.paymentForm.get(k)?.reset();
      }
      this.paymentForm.get(k)?.clearValidators();
      this.paymentForm.get(k)?.updateValueAndValidity();
    });
  }

  private applyValidatorsFor(id: string) {
    const phonePattern = /^\+?\d{8,15}$/;

    const set = (name: string, validators: any[]) => {
      const c = this.paymentForm.get(name);
      if (!c) return;
      c.setValidators(validators);
      c.updateValueAndValidity();
    };

    switch (id) {
      case 'mastercard_card':
        set('cardNumber', [Validators.required, Validators.pattern(/^[0-9 ]{12,19}$/)]);
        set('expiry', [Validators.required, Validators.pattern(/^(0[1-9]|1[0-2])\/?([0-9]{2})$/)]);
        set('cvv', [Validators.required, Validators.minLength(3), Validators.maxLength(4), Validators.pattern(/^[0-9]{3,4}$/)]);
        set('cardHolder', [Validators.required]);
        break;

      case 'tokenized_card':
        set('token', [Validators.required]);
        set('cardHolder', []); // optional
        break;

      case 'orange_money':
      case 'mtn_money':
      case 'free_money':
      case 'maxit':
      case 'wave_money':

        set('phone', [Validators.required, Validators.pattern(phonePattern)]);
        set('holderName', [Validators.required]);
        break;

       

      default:
        break;
    }
  }
 selectPayment(id: string) {
    this.selectedPaymentType = id;
    this.resetFormControls();
    this.applyValidatorsFor(id);
  }

 
    // stop polling and clear QR UI
  closeQr() {
    this.stopPolling();
    this.qrImageUrl = null;
    this.currentPaymentRef = null;
    // optionally keep form selection open or reset:
    // this.paymentForm.reset({ amount: 10 });
    // this.selectedPaymentType = null;
  }

  private stopPolling() {
    if (this.pollIntervalRef) {
      clearInterval(this.pollIntervalRef);
      this.pollIntervalRef = null;
    }
    this.polling = false;
    this.pollAttempts = 0;
  }

  cancelPayment() {
    this.selectedPaymentType = null;
    this.paymentForm.reset();
    this.stopPolling();      // ensure polling stopped if user cancels
    this.qrImageUrl = null;  // clear QR if present
    this.currentPaymentRef = null;
  }

  private markAllAsTouched() {
    Object.keys(this.paymentForm.controls).forEach(k => {
      this.paymentForm.get(k)?.markAsTouched();
    });
  }

  // helper used in template if needed
  getControl(name: string): AbstractControl | null {
    return this.paymentForm.get(name);
  }
}
